import styled from 'styled-components';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const Wrapper = styled.div<{ parentWidth?: number }>`
  display: flex;
  justify-content: space-between;
  gap: ${({ parentWidth }) =>
    parentWidth && parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd ? '12px' : '16px'};
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const Subtitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #4d4d4d;
`;

export const SubtitleRight = styled<any>(Subtitle)`
  text-align: right;
`;

export const StartTime = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #17181a;
`;

export const EndTime = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;

  text-align: right;

  color: #17181a;
`;
